export const locale = {
  lang: 'en',
  data: {
    PAYMENT_METHOD: {},
  },
};
